/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides all nessesary aria-* attributes to create valid multi-selection state
 */
export function ariaMultiSelectable() {
    return (target) => target.addInitializer((instance) => new AriaMultiSelectableController(instance));
}
export class AriaMultiSelectableController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostUpdated() {
        if (this.host.selectable !== undefined && this.host.selectable !== null) {
            this.host.ariaMultiSelectable = this.host.selectable === 'multi' ? 'true' : 'false';
        }
        else {
            this.host.ariaMultiSelectable = null;
        }
    }
}
